module.exports = __webpack_public_path__ + "static/media/wating.216e6336.webp";